var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteCross = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(-441 -714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "times-line",
    d: "M14.822,14.024,19.8,9.05A.6.6,0,0,0,18.95,8.2l-4.974,4.974-.846.846L8.15,19A.6.6,0,1,0,9,19.844l4.98-4.974Z",
    transform: "translate(433.06 705.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "times-line-2",
    "data-name": "times-line",
    d: "M6.882,5.964,11.856.99A.6.6,0,0,0,11.01.144L6.036,5.118l-.846.846L.21,10.938a.6.6,0,1,0,.846.846L6.036,6.81Z",
    transform: "translate(452.997 714) rotate(90)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteCross);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/White_Cross.efed794ceec621d09184b42553cb4b25.svg";